import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipRulesLifecycleModule } from './controllers/MembershipRulesLifecycleController';
import { MembershipLifecycleActionFormListDataResolver } from '@b2b/common/resolvers';

export const MembershipRulesLifecycleView = angular
  .module('acme.view.application.membership.rules.lifecycle', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.helpers',
    'acme.common.service.permissions',
    MembershipRulesLifecycleModule,
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    var membershipRulesLifecycle = {
      name: 'application.membership.rules.lifecycle',
      url: '/lifecycle',
      views: {
        'subview-main': {
          controller: 'MembershipRulesLifecycleController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/rules/lifecycle/lifecycle.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Lifecycle Rules   ',
        /** Secure With Permissions **/
        permissions: ['MEMBERSHIP_LIFECYCLE_RULES_VIEW'],
      },
      resolve: {
        MembershipLifecycleActionFormListData: MembershipLifecycleActionFormListDataResolver()
      },
    };

    $stateProvider.state(membershipRulesLifecycle);
  }).name;
